import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { ServiceContractPositionKind } from '../Enums/ServiceContractPositionKind.enum';

import { Article } from './Article.entity';
import { CostCenter } from './CostCenter.entity';
import { Supplier } from './Supplier.entity';

export class ServiceContractPosition<T extends EMode = EMode.entity> {
  /** Alias: anzahl */
  amount?: number;
  /** Alias: anzahlDecimal */
  amountDecimal?: number;
  /** Alias: anzahlLieferant */
  amountSupplier?: number;
  /** Alias: art */
  positionKind?: ServiceContractPositionKind;
  /** Alias: artikelCode */
  articleId?: number;
  /** Alias: artikelNummer */
  articleNumber?: string;
  /** Alias: bemerkung */
  comment?: string;
  /** Alias: code */
  id?: number;
  /** Alias: datum */
  date?: string;
  /** Alias: ekPreis */
  purchasePrice?: number;
  /** Alias: ekPreis2 */
  ekPreis2?: number;
  /** Alias: frei1 */
  free1?: string;
  /** Alias: frei2 */
  free2?: string;
  /** Alias: frei3 */
  free3?: string;
  /** Alias: frei4 */
  free4?: string;
  /** Alias: frei5 */
  free5?: string;
  /** Alias: gueltigAb */
  validFrom?: string;
  /** Alias: gueltigBis */
  validUntilDate?: string;
  /** Alias: herstellernummer */
  manufacturerNumber?: string;
  /** Alias: index */
  index?: number;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: kostenstelle */
  costCenterId?: number;
  /** Alias: kurztext */
  shortText?: string;
  /** Alias: langtext */
  longtext?: string;
  /** Alias: lieferantenCode */
  supplierId?: number;
  /** Alias: lieferantenText */
  supplierText?: string;
  /** Alias: positionsNummer */
  number?: string;
  /** Alias: preis */
  price?: number;
  /** Alias: preis2 */
  price2?: number;
  /** Alias: preis2AbDatum */
  price2StartDate?: string;
  /** Alias: prozent */
  percent?: number;
  /** Alias: rabatt */
  discount?: number;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: wartungspreisJahr */
  servicePricePerYear?: number;
  /** Alias: wartungsvertragCode */
  serviceContractId?: number;
  /** Alias: supplier */
  supplier?: Supplier<T>;
  /** Alias: article */
  article?: Article<T>;
  /** Alias: rabatt2 */
  discount2?: number;
  /** Alias: priceWithDiscount */
  priceWithDiscount?: number;
  /** Alias: costCenter */
  costCenter?: CostCenter<T>;
  /** Alias: altId */
  localId?: string;
  /** Alias: factor */
  factor?: number;

  __typename?: string;
}

const fields: FieldDefinitions<ServiceContractPosition> = {
  amount: {
    alias: 'anzahl',
  },
  amountDecimal: {
    alias: 'anzahlDecimal',
  },
  amountSupplier: {
    alias: 'anzahlLieferant',
  },
  positionKind: {
    alias: 'art',
  },
  articleId: {
    alias: 'artikelCode',
  },
  articleNumber: {
    alias: 'artikelNummer',
  },
  comment: {
    alias: 'bemerkung',
  },
  id: {
    alias: 'code',
  },
  date: {
    alias: 'datum',
  },
  purchasePrice: {
    alias: 'ekPreis',
  },
  ekPreis2: {
    alias: 'ekPreis2',
  },
  free1: {
    alias: 'frei1',
  },
  free2: {
    alias: 'frei2',
  },
  free3: {
    alias: 'frei3',
  },
  free4: {
    alias: 'frei4',
  },
  free5: {
    alias: 'frei5',
  },
  validFrom: {
    alias: 'gueltigAb',
  },
  validUntilDate: {
    alias: 'gueltigBis',
  },
  manufacturerNumber: {
    alias: 'herstellernummer',
  },
  index: {
    alias: 'index',
  },
  insertTime: {
    alias: 'insertTime',
  },
  costCenterId: {
    alias: 'kostenstelle',
  },
  shortText: {
    alias: 'kurztext',
  },
  longtext: {
    alias: 'langtext',
  },
  supplierId: {
    alias: 'lieferantenCode',
  },
  supplierText: {
    alias: 'lieferantenText',
  },
  number: {
    alias: 'positionsNummer',
  },
  price: {
    alias: 'preis',
  },
  price2: {
    alias: 'preis2',
  },
  price2StartDate: {
    alias: 'preis2AbDatum',
  },
  percent: {
    alias: 'prozent',
  },
  discount: {
    alias: 'rabatt',
  },
  updateTime: {
    alias: 'updateTime',
  },
  servicePricePerYear: {
    alias: 'wartungspreisJahr',
  },
  serviceContractId: {
    alias: 'wartungsvertragCode',
  },
  supplier: {
    alias: 'supplier',
    entity: Entities.supplier,
  },
  article: {
    alias: 'article',
    entity: Entities.article,
  },
  discount2: {
    alias: 'rabatt2',
  },
  priceWithDiscount: {
    alias: 'priceWithDiscount',
  },
  costCenter: {
    alias: 'costCenter',
    entity: Entities.costCenter,
  },
  localId: {
    alias: 'altId',
  },
  factor: {
    alias: 'factor',
  },
  __typename: {
    alias: '__typename',
  },
};

export const serviceContractPositionEntityDefinition: EntitiyDefinition<ServiceContractPosition> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'WartungsvertragPosition',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
